// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ReviewWriteFooter_wrapper__3B3OC"};